import { Typography } from 'antd';

import PageHeader from '../PageHeader';
import { Content, Wrapper } from './PageLayout.styled';

const { Title } = Typography;

interface PageLayoutProps {
  children: React.ReactNode;
  title: React.ReactNode | string;
  action?: React.ReactNode | void;
  style?: React.CSSProperties;
}

export const PageLayout = (props: PageLayoutProps) => {
  const { children, title, action, style } = props;

  const renderTitle = () => {
    if (title) {
      if (typeof title === 'string') {
        return <Title level={3}>{title}</Title>;
      } else {
        return <>{title}</>;
      }
    }
    return <></>;
  };

  return (
    <Wrapper>
      <PageHeader>
        {renderTitle()}
        {action ? <>{action}</> : <></>}
      </PageHeader>
      <Content style={style}>{children}</Content>
    </Wrapper>
  );
};

export default PageLayout;
